import React from 'react';
import { connect } from 'react-redux';
import {
	openSearchSongModal,
	toggleAddNewSongModal,
	toggleCountriesListModal,
	toggleCreatePlaylistModal,
	toggleUserPlaylistsModal
} from '../../state-management/actions/modal-actions';
import { NavigationBarButton, NavigationBarButtonLink } from './NavigationBarButtons';
import '../../style/NavigationBar.css';
import { fade, makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import Badge from '@material-ui/core/Badge';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MailIcon from '@material-ui/icons/Mail';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MoreIcon from '@material-ui/icons/MoreVert';
import { withRouter } from 'react-router-dom';

import logo from '../../images/mc.png';
import landingImage from '../../images/landing-image.jpg';

const useStyles = makeStyles(theme => ({
	grow: {
		// flexGrow: 1
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		display: 'none',
		[theme.breakpoints.up('sm')]: {
			display: 'block',
		},
	},
	search: {
		position: 'relative',
		borderRadius: theme.shape.borderRadius,
		backgroundColor: fade(theme.palette.common.white, 0.15),
		'&:hover': {
			backgroundColor: fade(theme.palette.common.white, 0.25),
		},
		marginRight: theme.spacing(2),
		marginLeft: 0,
		width: '100%',
		[theme.breakpoints.up('sm')]: {
			marginLeft: theme.spacing(3),
			width: 'auto',
		},
	},
	searchIcon: {
		width: theme.spacing(7),
		height: '100%',
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	inputRoot: {
		color: 'inherit',
	},
	inputInput: {
		padding: theme.spacing(1, 1, 1, 7),
		transition: theme.transitions.create('width'),
		width: '100%',
		[theme.breakpoints.up('md')]: {
			width: 200,
		},
	},
	sectionDesktop: {
		display: 'none',
		[theme.breakpoints.up('md')]: {
			display: 'flex',
		},
	},
	sectionMobile: {
		display: 'flex',
		[theme.breakpoints.up('md')]: {
			display: 'none',
		},
	},
	paper: { backgroundImage: `url(${landingImage})` }
}));

const ADD_NEW_SONG = 'ADD_NEW_SONG';
const CREATE_PLAYLIST = 'CREATE_PLAYLIST';
const DASHBOARD = 'DASHBOARD';
const EXPLORE = 'EXPLORE';
const PLAYLISTS = 'PLAYLISTS';
const RANDOM_PLAYLIST = 'RANDOM_PLAYLIST';
const SIGN_IN = 'SIGN_IN';
const SIGN_OUT = 'SIGN_OUT';
const SIGN_UP = 'SIGN_UP';


const viewNameMap = {
	'explore': [ADD_NEW_SONG, CREATE_PLAYLIST, DASHBOARD, PLAYLISTS, RANDOM_PLAYLIST, SIGN_IN, SIGN_OUT, SIGN_UP],
	'landing': [ADD_NEW_SONG, CREATE_PLAYLIST, DASHBOARD, PLAYLISTS, RANDOM_PLAYLIST, SIGN_IN, SIGN_OUT, SIGN_UP],
	'library': [ADD_NEW_SONG, CREATE_PLAYLIST, EXPLORE, PLAYLISTS, RANDOM_PLAYLIST, SIGN_IN, SIGN_OUT, SIGN_UP],
	'playlists': [ADD_NEW_SONG, CREATE_PLAYLIST, DASHBOARD, EXPLORE, RANDOM_PLAYLIST, SIGN_IN, SIGN_OUT, SIGN_UP],
	'confirmation': [ADD_NEW_SONG, CREATE_PLAYLIST, EXPLORE, PLAYLISTS, RANDOM_PLAYLIST, SIGN_IN]
}

const viewNamePermissions = (viewName) => {
	return viewNameMap[viewName];
}

function NavigationBar(props) {
	const classes = useStyles();

	const {
		history
	} = props;

	const viewName = history.location.pathname.substring(1).split('/')[0];

	// const viewsAllowed = viewNamePermissions(viewName);
	const viewsAllowed = [];
	// console.log('viewName', viewName);
	// console.log('viewsAllowed', viewsAllowed);


	const [anchorEl, setAnchorEl] = React.useState(null);
	const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

	const isMenuOpen = Boolean(anchorEl);
	const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

	const handleProfileMenuOpen = event => {
		setAnchorEl(event.currentTarget);
	};

	const handleMobileMenuClose = () => {
		setMobileMoreAnchorEl(null);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
		handleMobileMenuClose();
	};

	const handleMobileMenuOpen = event => {
		setMobileMoreAnchorEl(event.currentTarget);
	};


	const logOut = () => {
		const { logOutUser } = props;
		logOutUser();
	}

	const toggleAddNewSongModal = () => {
		props.toggleAddNewSongModal();
		handleMobileMenuClose();
	}

	const toggleCreatePlaylistModal = () => {
		props.toggleCreatePlaylistModal();
		handleMobileMenuClose();
	}

	const { authenticated } = props;
	// console.log('authh', authenticated);
	const menuId = 'primary-search-account-menu';

	const mobileMenuId = 'primary-search-account-menu-mobile';
	const renderMobileMenu = (
		<Menu
			anchorEl={mobileMoreAnchorEl}
			anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
			id={mobileMenuId}
			keepMounted
			transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			open={isMobileMenuOpen}
			onClose={handleMobileMenuClose}
			className='ref-mobile-menu'
			classes={{
				paper: classes.paper
			}}
		// style={{ backgroundImage: `url(${landingImage})` }}
		>
		</Menu>
	);

	return (
		<div className={classes.grow}>
			<AppBar
				position="static"
				style={{ background: 'rgb(249, 249, 249)', borderBottom: '2px solid #007EA7' }}
			// style={{ backgroundImage: `url(${landingImage})` }}
			>
				<Toolbar>

					{/* <img 
						src={logo} 
						alt="bug" 
						height={50} 
						style={{
							cursor:'pointer'
						}}
						onClick={()=> history.push('/')}
					/> */}
					
					<div  style={{
						color: '#007EA7'
					}}>
						<Typography variant='h6' gutterBottom>
							ANTHEMS OF THE WORLD
						</Typography>

					</div>
				</Toolbar>
			</AppBar>
			{renderMobileMenu}
		</div>
	);
}

export default withRouter(NavigationBar);
